"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useTracking } from "react-tracking";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { StyledLink, StyledLocationPin, StyledText } from "./styles.js";
function TextWithIcon({ entry }) {
  const { trackEvent } = useTracking();
  if (!entry) return null;
  const onClickHandler = () => {
    trackEvent({
      component: {
        trackedData: [
          entry.active_state.active_state_link.title
        ]
      }
    });
  };
  return /* @__PURE__ */ jsx(CostcoBox, { "data-testid": "findawarehouse-textwithicon", children: /* @__PURE__ */ jsxs(
    StyledLink,
    {
      href: entry.active_state.active_state_link.href,
      onClick: onClickHandler,
      children: [
        /* @__PURE__ */ jsx(StyledLocationPin, {}),
        /* @__PURE__ */ jsx(
          StyledText,
          {
            uniqueId: entry.active_state.active_state_link.title,
            children: entry.active_state.active_state_link.title
          }
        )
      ]
    }
  ) });
}
export {
  TextWithIcon
};
